import { Accordion } from 'semantic-ui-react';
import React from 'react';
import { dateFormat, currencyFormat, IsNotNullOrEmptyOrUndefined } from '../../util';
import { connect } from 'react-redux';

const ListadoDocumentosConfirmados = (props) => {
  const { documentos, emisor } = props;

  const renderTitle = (item) => {
    const clave = item?.Clave.slice(20, 50);
    let className = '';

    if (item.Estado === "APROBADO POR HACIENDA" || item.Estado === "0") {
      className = 'aceptado';
    } else {
      className = 'rechazado';
    }
    return (
      <>
        <div className="ui stackable row grid desktop">
          <div className="six wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Clave</span>
              </div>
              <div className="sixteen wide">
                <span className={className}>{`# ${clave}`}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Cédula Emisor:</span>
              </div>
              <div className="sixteen wide">
                <span>{item?.NumeroCedulaEmisor}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Nombre Emisor:</span>
              </div>
              <div className="sixteen wide">
                <span>{item?.NombreEmisor}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Cédula Receptor:</span>
              </div>
              <div className="sixteen wide">
                <span>{item?.NumeroCedulaReceptor}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Fecha:</span>
              </div>
              <div className="sixteen wide">
                <span>{dateFormat(item?.FechaEmisionDoc)}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Monto Impuestos: </span>
              </div>
              <div className="sixteen wide">
                <span>{currencyFormat(item?.MontoTotalImpuesto)}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Monto Total: </span>
              </div>
              <div className="sixteen wide">
                <span>{currencyFormat(item?.TotalFactura)}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Estado: </span>
              </div>
              <div className="sixteen wide">
                <span className={className}>{`${item?.Estado}`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="ui stackable row grid responsive">
          <div className="sixteen wide column">
            <span className={className}>{IsNotNullOrEmptyOrUndefined(item.Estado) ? item?.Estado : ""}</span>
          </div>
          <div className="sixteen wide column">
            <span>{`Clave: ${clave}`}</span>
          </div>
          <div className="sixteen wide column">
            <span>{`Fecha: ${dateFormat(item?.FechaEmisionDoc)}`}</span>
          </div>
          <div className="sixteen wide column">
            <span>Cédula Receptor: {item?.NumeroCedulaReceptor}</span>
          </div>
          <div className="sixteen wide column">
            <span>Cédula Emisor: {item?.NumeroCedulaEmisor}</span>
          </div>
          <div className="sixteen wide column">
            <span>Monto Total: {currencyFormat(item?.TotalFactura)}</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="ui listado-documentosconfirmacion-section">

      <Accordion fluid styled>
        {
          documentos.map((item, index) => (
            <div key={index}>
              <Accordion.Title
                index={index}
              >
                {renderTitle(item)}
              </Accordion.Title>
            </div>
          ))}
      </Accordion>
    </div>
  )
};

const mapStateToProps = (state) => {
  return {};
}

export default connect(mapStateToProps, {
})(ListadoDocumentosConfirmados);